// src/components/Header.jsx
import React, { useContext } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import { AuthContext } from "../context/AuthContext";

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout, userTier } = useContext(AuthContext);

  // Don't render header on login page
  if (location.pathname === '/login') return null;

  const handleDataClick = () => {
    if (user) {
      navigate('/data');
    } else {
      navigate('/login');
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const getTierDisplay = () => {
    if (!user?.email) return "Not Logged In";
    switch (userTier) {
      case 1:
        return "Trial Plan";
      case 2:
        return "Pay As You Go Plan";
      case 3:
        return "Enterprise Plan";
      default:
        return `Tier ${userTier}`;
    }
  };

  return (
    <header className="header">
      <div className="header-left">
        <img src="https://rekxup.s3.us-east-2.amazonaws.com/Public/Screen+Shot+2024-03-07+at+8.41.39+PM.png" alt="rekxup" className="logo" />
        <nav>
          <Link className={location.pathname === '/app' ? 'active' : ''} to="/app">
            Home
          </Link>
          <Link className={location.pathname === '/chat' ? 'active' : ''} to="/chat">
            Ask AI
          </Link>
          <Link 
            className={location.pathname === '/data' ? 'active' : ''} 
            to="/data"
            onClick={(e) => {
              e.preventDefault();
              handleDataClick();
            }}
          >
            Reconcile
          </Link>
          <Link className={location.pathname === '/data-insights' ? 'active' : ''} to="/data-insights">
            Chronic Mismatches
          </Link>
        </nav>
      </div>
      <div className="header-right">
        <div className="avatar">{user?.email ? user.email[0].toUpperCase() : "R"}</div>
        <div className="profile-info">
          <div className="email">{user?.email || "Guest"}</div>
          <div className="tier">{getTierDisplay()}</div>
        </div>
        {user?.email && (
          <button className="styled-logout-button" onClick={handleLogout}>
            Logout
          </button>
        )}
      </div>
    </header>
  );
}

export default Header;
